import { PaginatedBody } from "./generic.type";

export enum NotificationCategoryEnum {
  CM = "CM",
  CM_SHEET = "CMSHEET",
  CV = "CV",
  INFO = "INFO",
  SYS = "SYS",
}

export interface Notification {
  id: number;
  title: string;
  category: NotificationCategoryEnum;
  body: string;
  created_at: string;
  read: boolean;
}

export type GetNotificationsResponse = PaginatedBody<Notification>;

export type GetNotificationsCounters = {
  all: number;
  unread: number;
  read: number;
};
